
export const useChatStore = defineStore('chat', () => {

    const config = useRuntimeConfig()
    const baseIM = config.public.baseIM

    // 当前登录用户信息
    const user = ref({})

    const isConnect = ref(false)
    // 连接状态 0: 未连接 1: 连接中 2: 已连接 3: 已断开
    const connectSta = ref(0)

    const receive = ref([])
    const receiveGetter = computed(() => receive.value)
    const localMessages = ref([])
    const onNewMessage = ref(Date.now())
    const onPlayMsgAudio = ref(Date.now())//消息提示音
    // 会话列表
    const chatList = ref([])
    const conversations = computed(() => chatList.value)
    // 当前正在聊天的会话
    const curConversiton = ref({})
    // 最新消息的会话
    const newMsgConversation = ref({})


    // 创建webboteSocket连接
    const ws = ref(null)
    function createConnection(token) {

        return new Promise((resolve, reject) => {
            if (connectSta.value == 2) {
                console.log('连接已存在,请不要重复连接')
                reject('连接已存在,请不要重复连接')
                return
            }
            console.log('创建连接')
            connectSta.value = 1
            ws.value = new WebSocket(baseIM + '?token=' + token)

            ws.value.onopen = () => {
                console.log('聊天连接成功')
                isConnect.value = true
                connectSta.value = 2
                resolve()
            }

            ws.value.onmessage = async (e) => {
                console.log('接收到消息：', e.data)
                await reqChatList()

                onNewMessage.value = Date.now() + '' + Math.random() * 10000
                try {
                    const messageBody = JSON.parse(e.data)
                    console.log('messageBody', messageBody)
                    for (let i = 0; i < conversations.value.length; i++) {
                        if (messageBody.groupId == conversations.value[i].groupId) {
                            newMsgConversation.value = conversations.value[i]
                            break
                        }
                    }
                    // 判断该条消息是否属于当前会话
                    if (messageBody.groupId == curConversiton.value.groupId) {

                        let isReceive = true // 判断该条消息是收到的还是发出的

                        for (let i = 0; i < receive.value.length; i++) {
                            if (receive.value[i]?.object?.id == messageBody?.object?.id) {
                                //如果是发出的消息，则设置消息的发送成功状态
                                messageBody.sendSuccess = true
                                receive.value[i] = messageBody
                                isReceive = false
                                break
                            }
                        }
                        console.log('isReceive', isReceive)
                        // 如果是收到的消息,则将消息push到receive数组中
                        const isExist = chatList.value.some(item => messageBody.groupId == item.groupId)
                        if (isReceive && isExist) {
                            onPlayMsgAudio.value = Date.now() + '' + Math.random() * 1000000
                            receive.value.push(messageBody)
                        }
                    } else {
                        onPlayMsgAudio.value = Date.now() + '' + Math.random() * 1000000
                    }
                } catch (error) {
                    console.log('消息解析出错：：', error)
                }

            }

            ws.value.onclose = () => {
                console.log('聊天连接已关闭')
                isConnect.value = false
                connectSta.value = 3
            }
        })

    }

    // 关闭连接
    function close() {
        ws.value.close()
    }
    
    // 请求聊天会话列表
    const reqChatListLoading = ref(false)
    async function reqChatList() {

        if (reqChatListLoading.value) return

        reqChatListLoading.value = true

        const { data } = await request('/website/tourism/fans/getTourMemberList').finally(() => reqChatListLoading.value = false)
        const { list } = data || {}
        if (Array.isArray(list)) {
            // 找到当前会话，清除未读消息
            for (let i = 0; i < list.length; i++) {
                if (list[i].groupId == curConversiton.value?.groupId) {
                    curConversiton.value = list[i]
                    list[i].unreadMessageCount = 0
                    break;
                }
            }
            chatList.value = list
        }
    }

    const messages = ref('first message')

    const newMessageLoading = ref(false)
    async function getNewMessage(groupId, messageId) {
        console.log(groupId, messageId)

        if (newMessageLoading.value) return

        if (!groupId || !messageId) return

        const query = {
            groupId, messageId
        }
        newMessageLoading.value = true
        const { data } = await request('/website/tourMessage/getLatestMessage', { query }).finally(() => newMessageLoading.value = false)
        localMessages.value = []
        receive.value = [...receive.value, ...data]
        console.log('新消息：', res)
    }

    /**
     * 设置会话 
     * isTop 是否置顶0否1是 
     * isNotDisturb 是否免打扰0否1是 
     * isShow 是否显示0否1是
     * */
    async function setConversation(data = {}) {

        const { groupId, isTop, isNotDisturb, isShow } = data || {}

        if (!groupId) return

        if (isTop != 0 && isTop != 1 && isNotDisturb != 0 && isNotDisturb != 1 && isShow != 0 && isShow != 1) {
            return
        }

        await request('/website/tourMember/updateSingleTourMember', { method: 'post', body: data })

        // 如果删除的会话是正在聊天的会话，则将当前会话置空
        if (groupId == curConversiton.value.groupId && isShow == 0) {

            curConversiton.value = {}

        }

        ElMessage.success('操作成功')

        reqChatList()

    }

    // 关注、取关
    const followLoadding = ref(false)
    async function handleFollow(id, fansStatus) {

        if (!id) return

        if (fansStatus != 0 && fansStatus != 1 && fansStatus != 2 && fansStatus != 4) return

        // 确保每次操作请求结束后 再执行下一次操作
        if (followLoadding.value) return

        followLoadding.value = true
        ElLoading.service({
            lock: true,
            background: 'rgba(0, 0, 0, 0.2)'
        })
        await request('/website/tourism/fans/saveConcern', { method: 'post', body: { attentionId: id } }).finally(() => {
            followLoadding.value = false
            ElLoading.service().close()
        })

        ElMessage.success('操作成功')

    }

    /**
     * 创建会话
     * @param {Object} data 
     * data.getUserId 接收者id(对方)
     * data.sendUserId 发送者id(自己)
     * data.groupId 如果是单聊，就在本地创建一个groupId，如果是群聊，必须传一个真实存在的groupId
     * */
    async function createConversation(data = {},) {

        const { getUserId, sendUserId, groupId, noticeType } = data

        if (noticeType != 1 && noticeType != 2) return

        if (noticeType == 1 && !getUserId) return ElMessage.error('缺少必要参数')

        if (!sendUserId || !groupId) return ElMessage.error('缺少必要参数')

        ElLoading.service({
            lock: true,
            background: 'rgba(0, 0, 0, 0.3)'
        })
        await request('/website/tourGroup/createMember', { method: 'post', body: data }).finally(() => ElLoading.service().close())

        await reqChatList()

        if (noticeType == 1) {
            for (let i = 0; i < chatList.value.length; i++) {
                if (chatList.value[i].toUserId == getUserId) {
                    curConversiton.value = chatList.value[i]
                    break
                }
            }
        }

        if (noticeType == 2) {
            for (let i = 0; i < chatList.value.length; i++) {
                if (chatList.value[i].groupId == groupId) {
                    curConversiton.value = chatList.value[i]
                }
            }
        }

    }
    /**
     *  获取系统消息和关注消息
     *  @param {number} noticeType 1单聊 2群聊 3系统消息 4关注消息 5点赞通知 6评论通知 7收藏通知 8浏览通知 9访问主页通知 10评论区艾特通知 11文章内艾特通知
     *  @param {number} pageSize 每页条数
     *  @param {number} pageNum 页码
     * */
    async function getListSystemAndFocusMessages(obj = {}) {
        return new Promise(async (resolve, reject) => {

            const query = { ...obj }
            const res = await request('/website/tourMessage/getsListSystemAndFocusMessages', { query })
            resolve(res)
        })
    }

    /**
     * 清除未读消息
     * @param {number} groupId 会话id
    */
    async function updateRead(groupId) {
        if (!groupId) return
        const query = { groupId }
        await request('/website/tourMessage/updateRead', { query })
    }

    return {
        messages,
        reqChatList,
        createConnection,
        ws,
        conversations,
        curConversiton,
        receive,
        receiveGetter,
        user,
        chatList,
        isConnect,
        connectSta,
        onNewMessage,
        setConversation,
        handleFollow,
        createConversation,
        getListSystemAndFocusMessages,
        updateRead,
        close,
        newMsgConversation
    }
})